import React from 'react';
import {Button, ButtonGroup, Icon} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';
import {Tooltip2} from '@blueprintjs/popover2';

import {TRIGGER_TYPE} from '../constants';
import {webhookIcon} from '../../../../utils/custom-icons';

interface SelectTriggerTypeProps {
  type: string;
  onChange: (type: string) => void;
  hasWebhook: boolean;
}

const SelectTriggerType = ({type, onChange, hasWebhook}: SelectTriggerTypeProps) => {
  return (
    <ButtonGroup fill={true} className="select-trigger-type">
      <Button
        text="Schedule"
        icon={IconNames.CALENDAR}
        active={type === TRIGGER_TYPE.WORKFLOW}
        onClick={() => onChange(TRIGGER_TYPE.WORKFLOW)}
      />
      <Tooltip2
        hoverOpenDelay={800}
        content="Only one webhook trigger is allowed."
        disabled={!hasWebhook}
        compact={true}
        usePortal={false}
      >
        <Button
          text="Webhook"
          icon={webhookIcon({})}
          active={type === TRIGGER_TYPE.WEBHOOK}
          onClick={() => onChange(TRIGGER_TYPE.WEBHOOK)}
          disabled={hasWebhook}
        />
      </Tooltip2>
    </ButtonGroup>
  )
}

export default SelectTriggerType;
